import {
  createI18nRouting,
  DEFAULT_LOCALE,
  DEFAULT_LOCALES,
} from '@repo/ui/i18n/config';

export const routing = createI18nRouting(DEFAULT_LOCALES, DEFAULT_LOCALE);
